import React from 'react';
import {Flex, Box} from '@chakra-ui/react';
import {useCustomer} from '../../../../hooks/api/metadata';
import {getCreditsNeededForEnrichment} from '../../../../shared/credits';
import {pluralize} from '../../../../lib/helpers';
import {Credits} from '../../../Icons/Credits';
import {useAgentFields} from '../helpers';
import {useAgentBuilderServerState} from '../AgentBuilder.state';
import {assertExists} from '../../../../shared/util';

export const CreditsSection = () => {
  const agentId = useAgentBuilderServerState().id;
  const {analystField, researcherField} = useAgentFields(agentId);
  // Prefer passing in the analyst field to the credit calculation since it will handle the case
  // if there are researcher dependencies.
  const primaryField = assertExists(analystField ?? researcherField);

  const customer = useCustomer();
  const numCredits = getCreditsNeededForEnrichment({
    fields: customer.fieldDefinitions,
    fieldId: primaryField.id,
    numAccounts: 1,
  });

  return (
    <Flex gap="2" alignItems="center">
      <Flex
        alignItems="center"
        bgColor="kred.50"
        borderRadius="full"
        px="10px"
        py="5px"
        color="kred.400"
        gap="2"
      >
        <Credits />
        {numCredits}
      </Flex>
      <Box color="kgray.300">
        This agent will use{' '}
        <Box as="span" color="kgray.500" fontWeight="500">
          {pluralize(numCredits, 'credit', 'credits')}
        </Box>{' '}
        per account enriched.
      </Box>
    </Flex>
  );
};
